import React from 'react'
import withAccountsLayout from '../../withAccountsLayout'

function DepartmentCollectionReportpage() {
  return (
    <div>DepartmentCollectionReportpage</div>
  )
}

export default withAccountsLayout(DepartmentCollectionReportpage)